import React, { useEffect, useState } from "react";
import {
  RiUserLine,
  RiPhoneFill,
  RiMailLine,
  RiSave2Fill,
  RiShieldUserLine,
} from "react-icons/ri";
import { Formik } from "formik";
import * as Yup from "yup";
import Axios from "../../Axios";
import { useAuthContext } from "../../context/AuthContext";
import { MyInput } from "../../ui";
import FileUploader from "../../admin/utils/FileUploader/FileUploader";
import Popup from "../../utils/Popup/Popup";
import Loader from "../../utils/Loader/Loader";
import "./profile.scss";

const schema = Yup.object().shape({
  firstname: Yup.string().required("Хоосон байна!"),
  lastname: Yup.string().required("Хоосон байна!"),
  phone_number: Yup.string().required("Хоосон байна!"),
});

const Profile = () => {
  const { authConfig } = useAuthContext();

  const [userData, setUserData] = useState({});
  const [imageFile, setImageFile] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const [popupType, setPopupType] = useState("");
  const [popupText, setPopupText] = useState("");
  const [visiblePopup, setVisiblePopup] = useState(false);

  useEffect(() => {
    if (authConfig) {
      Axios.get("/auth/me", authConfig).then((res) => {
        if (res.status === 200) {
          setUserData(res.data);
        }
      });
    }
  }, [authConfig]);

  const saveHandler = (values) => {
    setIsLoading(true);

    const formData = new FormData();
    formData.append("id", userData.id);
    formData.append("firstname", values.firstname);
    formData.append("lastname", values.lastname);
    formData.append("phone_number", values.phone_number);
    formData.append("avatar", userData.avatar);
    formData.append("imageFile", imageFile);

    if (authConfig) {
      Axios.put("/users", formData, authConfig)
        .then((res) => {
          if (res.data.message === "success") {
            setPopupType("success");
            setPopupText("Амжилттай хадгалагдлаа");
          } else {
            setPopupType("sys_error");
            setPopupText("Ямар нэгэн алдаа гарлаа. Та дахин оролдоно уу!");
          }
          setVisiblePopup(true);
        })
        .catch(() => {
          setPopupType("sys_error");
          setPopupText("Ямар нэгэн алдаа гарлаа. Та дахин оролдоно уу!");
          setVisiblePopup(true);
        })
        .finally(() => {
          setIsLoading(false);
        });
    } else {
      setPopupType("sys_error");
      setPopupText("Ямар нэгэн алдаа гарлаа. Та дахин оролдоно уу!");
      setVisiblePopup(true);
      setIsLoading(false);
    }
  };

  return (
    <div className="profilePage">
      <Popup
        messageType={popupType}
        messageText={popupText}
        visible={visiblePopup}
        onOk={() => window.location.reload()}
      />

      <div className="profileCard">
        <div className="profileCard__header">
          <div>
            <div className="profileCard__eyebrow">Миний бүртгэл</div>
            <h2 className="profileCard__title">Хэрэглэгчийн мэдээлэл</h2>
            <p className="profileCard__desc">
              Хувийн мэдээллээ шинэчилж, зураг болон холбоо барих мэдээллээ
              засна уу.
            </p>
          </div>

          <div className="profileCard__badge">
            <RiShieldUserLine />
            <span>Профайл</span>
          </div>
        </div>

        {Object.keys(userData).length > 0 && (
          <Formik
            initialValues={{
              firstname: userData.firstname || "",
              lastname: userData.lastname || "",
              phone_number: userData.phone_number || "",
              email: userData.email || "",
            }}
            validationSchema={schema}
            onSubmit={(values) => saveHandler(values)}
            enableReinitialize
          >
            {({
              values,
              errors,
              touched,
              setFieldTouched,
              handleChange,
              handleSubmit,
            }) => (
              <form className="profileForm" onSubmit={handleSubmit}>
                <div className="profileForm__top">
                  <div className="profileAvatarCard">
                    <div className="profileAvatarCard__title">
                      Профайл зураг
                    </div>
                    <div className="profileAvatarCard__subtitle">
                      PNG, JPG зураг сонгох боломжтой
                    </div>

                    <div className="profileAvatarCard__uploader">
                      <FileUploader
                        file={userData.avatar}
                        getFile={setImageFile}
                        center
                        avatar
                      />
                    </div>
                  </div>

                  <div className="profileInfoCard">
                    <div className="profileInfoCard__grid">
                      <div className="profileField">
                        <label className="profileField__label">Овог</label>
                        <MyInput
                          icon={<RiUserLine />}
                          name="lastname"
                          value={values.lastname}
                          onChange={handleChange}
                          onBlur={setFieldTouched}
                          touched={touched.lastname}
                          errorText={errors.lastname}
                        />
                      </div>

                      <div className="profileField">
                        <label className="profileField__label">Нэр</label>
                        <MyInput
                          icon={<RiUserLine />}
                          name="firstname"
                          value={values.firstname}
                          onChange={handleChange}
                          onBlur={setFieldTouched}
                          touched={touched.firstname}
                          errorText={errors.firstname}
                        />
                      </div>

                      <div className="profileField">
                        <label className="profileField__label">
                          Утасны дугаар
                        </label>
                        <MyInput
                          icon={<RiPhoneFill />}
                          name="phone_number"
                          value={values.phone_number}
                          onChange={handleChange}
                          onBlur={setFieldTouched}
                          touched={touched.phone_number}
                          errorText={errors.phone_number}
                        />
                      </div>

                      <div className="profileField">
                        <label className="profileField__label">Имэйл</label>
                        <MyInput
                          icon={<RiMailLine />}
                          value={values.email}
                          disabled
                        />
                      </div>
                    </div>

                    <div className="profileForm__actions">
                      {isLoading ? (
                        <Loader mini />
                      ) : (
                        <button className="profileSaveBtn" type="submit">
                          <RiSave2Fill />
                          <span>Хадгалах</span>
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </form>
            )}
          </Formik>
        )}
      </div>
    </div>
  );
};

export default Profile;
